export const isAllFieldsValid = (state) => {
  const fieldsKeys = Object.keys(state);
  return fieldsKeys.every((key) => state[key].isValid);
};

export const isShowErrorMessage = (key, state) =>
  Boolean(
    state[key]?.isDirty &&
      !state[key]?.isValid &&
      !state[key]?.isFocused &&
      state[key]?.errorMessages?.length > 0
  );

export const isFieldValid = (key, state) => Boolean(state[key]?.isValid);

export const fieldHasErrors = (key, state) => {
  const field = state[key];
  return field?.isDirty && !field?.isValid && field?.errorMessages?.length > 0 && !field?.isFocused;
};

export const getErrorTitle = (errors) => errors?.[0]?.title ?? '';
